import { MULTI_ACCOUNTS_API } from "../../../js/shared/constants";
import { getUserToken } from "./utils";
import axios from "axios";

/**
 *  Configure settings to do requests
 */
let http = axios.create({
	baseURL: MULTI_ACCOUNTS_API
});

// SET DEFAULT HEADERS
http.interceptors.request.use(
	config => {
		config.headers.Authorization = getUserToken();
		return config;
	},
	error => {
		return Promise.reject(error);
	}
);

/**
 * ADVANCED MANAGEMENT REQUESTS
 */

/**
 * Make a research to get participant's data from CPF
 * @param {String} cpf
 */
export const searchByCPF = cpf =>
	http.get("/participant/cpf", {
		params: {
			cpf
		}
	});

/**
 * Make a research to look current user's relationships
 */
export const getManagerRelationships = () => http.get("/manager");

/**
 * Make a request to approve relationship
 */
export const approveRelationship = data =>
	http.post("/manager/approve", data);

/**
 * Make a research to invite a participant
 */
export const inviteParticipant = data => http.post("/manager/invite", data);

/**
 * Make a research to cancel relationship
 */
export const cancelRelationship = data => http.post("/manager/cancel", data);

//  END ADVANCED MANAGEMENT REQUESTS

//  ACCOUNT LINK REQUESTS - Vínculo de conta (participante)

/**
 * Procura um gestor pelo CPF
 * @param {String} cpf CPF a ser buscado
 * @param {String} relationshipId Id da relação entre gestor e participante
 */
export const getManagerByCPF = (cpf, relationshipId) =>
	http.get("/manager/cpf", {
		params: {
			cpf,
			id: relationshipId
		}
	});

/**
 * Retorna o lista de vínculos do participante
 */
export const getParticipantRelationships = () => http.get("/participant");

/**
* Participante aprova a indicação
*/
export const participantApproveInvite = data =>
   http.post("/participant/approve", data);

/**
 * Participante cancela vínculo
 */
export const participantCancelRelationship = data => http.post("/participant/cancel", data);

//   END ACCOUNT LINK REQUESTS

//  UPLOAD FILES

/**
 * Retorna URL e Key para fazer upload do arquivo
 * @param {String} relationshipId Id da relação entre gestor e participante
 */
export const getUploadFileURL = (relationshipId) =>
	http.get(`/document/url/${relationshipId}`);

//  END UPLOAD FILES
